import { func } from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import {
  editModalPanels,
  useRecurringGifts,
} from "CrossFeatureComponents/UserRecurringGifts/RecurringGiftsContext";
import Notice from "Payments/Shared/Notice";

import { colors } from "UI/colors";

export default function UpdateNotice({ setNoticeMessage }) {
  const { state, dispatch } = useRecurringGifts();
  const { isSubmitting } = state.editModal;

  const switchScreenAndOpenModal = () => {
    if (isSubmitting) return;
    dispatch({
      type: "setCurrentPanel",
      payload: editModalPanels.edit,
    });
    setNoticeMessage(null);
    dispatch({
      type: "setCurrentPanel",
      payload: editModalPanels.paymentMethods,
    });
  };

  return (
    <NoticeButton as="button" onClick={switchScreenAndOpenModal}>
      <i className="fas fa-exclamation-triangle" />
      &nbsp; Needs updating
    </NoticeButton>
  );
}

UpdateNotice.propTypes = {
  setNoticeMessage: func,
};

const NoticeButton = styled(Notice)`
  width: max-content;
  border-width: 1px;
  font-size: 12px;
  font-weight: 600;
  padding-block: 2px;
  border-radius: 6px;
  color: ${colors.fnRedNotice};
  background-color: ${colors.fnYellowNotice};
  border-color: ${colors.fnRedNotice};
  border-style: solid;
  border-image: none;
  cursor: pointer;
`;
